import type { InputHTMLAttributes } from 'react';
import { forwardRef } from 'react';

import { TextInput } from '../../inputs/TextInput/TextInput';
import { DefaultFormFieldLayout } from '../DefaultFormFieldLayout/DefaultFormFieldLayout';
import type { HelperText } from '../FormFieldHelperText/FormFieldHelperText';

export type CoreFormFieldEmailProps = {
  inputProps: InputHTMLAttributes<HTMLInputElement>;
  label?: React.ReactNode;
  error?: string;
  helperText?: HelperText;
  inline?: boolean;
};

export const CoreFormFieldEmail = forwardRef(function _CoreFormFieldEmail(
  { error, helperText, inline, inputProps, label }: CoreFormFieldEmailProps,
  ref: React.Ref<HTMLInputElement>
) {
  return (
    <DefaultFormFieldLayout
      label={label}
      error={error}
      inputId={inputProps.id}
      inline={inline}
      helperText={helperText}
    >
      <TextInput
        data-testid={inputProps.id}
        {...inputProps}
        type="email"
        error={error}
        ref={ref}
      />
    </DefaultFormFieldLayout>
  );
});
